import React from 'react';

interface Props {
    children: React.ReactNode;
    color: string;
}
const Content: React.FC<Props> = ({ children, color }) => {
    return <div style={{ width: '100%', color: color }}>{children}</div>;
};

export { Content };
